module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-mask-parent"
  }, [_c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('canvas', {
    ref: "my-canvas"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-162e81d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CanvasChart.vue
// module id = 1239
// module chunks = 2